import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useApi } from "@/lib/api";

const SiteCtx = createContext({ categories: [], settings: { social: {} } });
export const useSite = () => useContext(SiteCtx);

function upsertMeta(name, content) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function useAnalytics(gaId) {
  const location = useLocation();
  useEffect(() => {
    if (!gaId || window.__gaLoaded) return;
    window.__gaLoaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", gaId, { send_page_view: false });
  }, [gaId]);
  useEffect(() => {
    if (gaId && window.gtag && !location.pathname.startsWith("/admin")) {
      window.gtag("event", "page_view", { page_path: location.pathname + location.search, page_title: document.title });
    }
  }, [gaId, location.pathname, location.search]);
}

export function SiteProvider({ children }) {
  const { data } = useApi("/public/bootstrap");
  const value = data || { categories: [], settings: { social: {}, site_url: "https://saaspivora.com" } };
  useAnalytics(value.settings.ga4_id);
  useEffect(() => {
    if (value.settings.gsc_verification) upsertMeta("google-site-verification", value.settings.gsc_verification);
  }, [value.settings.gsc_verification]);
  return <SiteCtx.Provider value={{ ...value, loaded: !!data }}>{children}</SiteCtx.Provider>;
}

export const categoryName = (categories, slug) => categories.find((c) => c.slug === slug)?.name || slug;
